import angular from "angular";
import {SHARE_ITEM_TYPE} from "@common/share/components/shareItem/share-item.directive";
import {Util} from "@common/util";
import {User, UserNotiTypeEnum} from "@common/model/user";
import {CacheService} from "@common/service/cache.service";
import {JavaApiAdapterService} from "@common/apiadapter/javaapi.service";
import {BroadcastService} from "@common/service/broadcast.service";
import {Organization} from "@common/model/organization";

export class GeneralSharePopupController {
    participants : User[];
    participantsOrgs : Organization[];
    newItem;
    displayAs : string;
    hasSelectedEntities : boolean;
    isConfirmScreen : boolean;
    currentOrg : Organization;
    static $inject = ["$timeout", "$scope", "CacheService", "ApiAdapterService", "$uibModal", "$uibModalInstance", "item", "itemId", "displayAs", "eligibleUsers", "sharedUsers",
        "headerIcon", "newItem", "iconBgColor", "addTMOption", "msgs", "BroadcastService"];

    constructor(private $timeout : angular.ITimeoutService, $scope : angular.IScope, private $_cache : CacheService, private $_api : JavaApiAdapterService, private $uibModal : angular.ui.bootstrap.IModalService,
                private $uibModalInstance : angular.ui.bootstrap.IModalInstanceService, item, itemId : number, displayAs : string, eligibleUsers, sharedUsers, headerIcon : string, newItem,
                iconBgColor : string, addTMOption, msgs, private BroadcastService : BroadcastService) {
        let gShareVm: any = this;
        gShareVm.item = item;
        gShareVm.displayAs = displayAs;
        gShareVm.headerIcon = headerIcon;
        gShareVm.iconBgColor = iconBgColor;
        gShareVm.eligibleUsers = eligibleUsers;
        gShareVm.sharedUsers = sharedUsers;
        gShareVm.addTMOption = addTMOption;
        gShareVm.msgs = msgs;
        gShareVm.currentOrg = null;
        gShareVm.newItem = newItem;
        gShareVm.participants = angular.copy(sharedUsers);
        gShareVm.hasSelectedEntities = false;
        gShareVm.participantsOrgs = [];
        gShareVm.flag = false;
        gShareVm.cnclFlag = false;
        gShareVm.mcnclFlag = false;
        gShareVm.mflag = false;
        gShareVm.msbmtflag = false;
        gShareVm.itemId = itemId;
        gShareVm.isConfirmScreen = false;
        gShareVm.shareItemsTypes = SHARE_ITEM_TYPE;
        gShareVm.closeMsg = "You have unsaved changes! They will be lost if you close this pop-up.<br /> Click ‘<i class='fa fa-long-arrow-left'></i>’ again to continue.";
        gShareVm.cnclMsg = "Click this button again to discard any changes and go back. ";
        let config = Util.getTextConfigForSharePopup();
        gShareVm.textConfig = config[this.displayAs];
        if (gShareVm.displayAs == SHARE_ITEM_TYPE.DOCUMENT) {
            gShareVm.textConfig = (gShareVm.newItem ? gShareVm.textConfig.uploadFlow : gShareVm.textConfig.shareFlow);
            gShareVm.textConfig.msgVars = config[this.displayAs].msgVars;
            gShareVm.textConfig.confirmTitle = config[this.displayAs].confirmTitle;
        }
        BroadcastService.registerCallBack('close-share-popup', $scope.$id, () => {
            this.closePopup();
        });

        $scope.$on("$destroy", function () {
            BroadcastService.removeCallBack('close-share-popup', $scope.$id);
        });
        if (window.innerWidth < 768) {
            $timeout(() => {
                let h = $('.share-container .modal-content').height();
                $('.share-container .modal-content').css('height', h + 'px');
            }, 100);
        }
    }

    toggleConfirmScreen = (isConfirming) => {
        this.isConfirmScreen = isConfirming;
        this.$timeout(() => {
            this.BroadcastService.broadcast('confirm-screen-toggled');
        }, 100);
    }

    shareSkipOrConfirm = () => {
        if (this.hasSelectedEntities) {
            if (this.isConfirmScreen) {
                this.BroadcastService.broadcast('share-entities');
            } else {
                this.toggleConfirmScreen(true);
            }
        } else if (this.newItem) {
            let currentUser = this.$_cache.getUser();
            let uNotification = currentUser.userNotifications.find(n => n.notificationType == UserNotiTypeEnum.AVOID_SKIP_SHARE);
            if (typeof uNotification == 'object' && uNotification.isDeleted == false) {
                this.$uibModal.open({
                    templateUrl: 'app/common/share/components/skipSharing/skipSharing.html',
                    controller: 'SkipSharingController as skipShareVm',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        displayAs: () => this.displayAs
                    }
                }).result.then((flag) => {
                    if (flag) {
                        uNotification.isDeleted = true;
                        this.$_api.updateUserNotificationAlertFlag(uNotification);
                    }
                    this.closePopup();
                });
            } else {
                this.closePopup();
            }
        } else {
            this.closePopup();
        }
    }

    closePopup = (): void => {
        if (this.displayAs == SHARE_ITEM_TYPE.DOCUMENT && this.newItem) {
            if (this.currentOrg) {
                //in case of upload and share, current org is by default selected so this is required here to handle skipshare
                this.participantsOrgs.push(this.currentOrg);
            }
            this.$uibModalInstance.close({participants: this.participants, participantsOrgs: this.participantsOrgs});
        } else {
            this.$uibModalInstance.close(this.participants);
        }
    }

    cancelPopup = (): void => {
        if (this.isConfirmScreen) {
            this.toggleConfirmScreen(false);
        } else {
            this.$uibModalInstance.dismiss();
        }
    }

}

angular.module('eCareVault.common.share')
    .controller('GeneralSharePopupController', GeneralSharePopupController);
